import { createContext, useEffect, useReducer } from 'react'

const CacheContext = createContext()

export const CACHE_KEY = {
  OWNERSHIP: 'ownership',
  MANUFACTURER: 'manufacturer',
  MFR_PROFILE: 'manufacturerProfile'
}

const cacheReducer = (state, action) => {
  switch (action.type) {
    case 'set':
      return { ...state, [action.key]: action.value }
    case 'remove': {
      const newState = { ...state }
      delete newState[action.key]
      return newState
    }
    case 'removeStartingWith': {
      const newState = { ...state }
      const keysStartingWith = Object.keys(newState).filter(k => k.startsWith(action.key)) || []
      keysStartingWith.forEach(key => {
        delete newState[key]
      })
      return newState
    }
    default:
      return state
  }
}
const initialState = {}

export const CacheContextProvider = ({children}) => {
  const [cacheMap, dispatch] = useReducer(cacheReducer, initialState)

  const getItem = (key) => {
    if (cacheMap && Object.keys(cacheMap).includes(key)) {
      const cacheEntry = cacheMap[key]
      if (cacheEntry.expiresAt && cacheEntry.expiresAt < new Date().getTime()) {
        return null
      }
      return cacheEntry.item
    }
    return null
  }

  const setItem = (key, item, ttlSeconds = undefined) => {
    const expiresAt = ttlSeconds ? new Date().getTime()+(ttlSeconds*1000) : undefined
    dispatch({type: 'set', key, value: { item, expiresAt }})
  }

  const removeItem = (key) => {
    if (cacheMap) {
      dispatch({type: 'remove', key })
    }
    return null
  }

  const removeItemsStartingWith = (key) => {
    if (cacheMap) {
      dispatch({type: 'removeStartingWith', key })
    }
    return null
  }

  const removeAll = () => {
    if (cacheMap) {
      Object.keys(cacheMap).forEach(key => dispatch({type: 'remove', key }))
    }
    return null
  }

  useEffect(() => {
    console.log('Cache initialization')
  }, [])

  const contextValue = {
    cacheMap,
    getItem,
    setItem,
    removeItem,
    removeItemsStartingWith,
    removeAll
  }
  return (
    <CacheContext.Provider value={contextValue}>
      {children}
    </CacheContext.Provider>
  );
}

export default CacheContext